import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

export const Skeleton = styled.div`
  background: linear-gradient(90deg, #ececef 0%, #f7f7fa 50%, #ececef 100%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
  border-radius: 4px;
`;

export const RecentLowRatingsStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 6px;

  .lowrate-card {
    display: block;
    padding: 12px;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    background: #fff;
    text-decoration: none;
    color: inherit;
    transition: border-color 0.12s, background 0.12s;
  }
  .lowrate-card:hover {
    border-color: ${({ theme }) => theme.colors.accent[500]};
    background: ${({ theme }) => theme.colors.accent[50]};
  }
  .lowrate-card--skeleton {
    pointer-events: none;
  }

  .lowrate-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .lowrate-grade {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
  }

  .lowrate-svc {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .lowrate-id {
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .lowrate-time {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .lowrate-text {
    margin: 6px 0;
    font-size: 13px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .lowrate-meta {
    display: flex;
    gap: 16px;
    font-size: 11px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .lowrate-meta b {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin-right: 2px;
  }
`;
